import React from 'react';
import { getGetBuslineSchedulesQueryOptions } from '@area-restrita/api-client/endpoints/busline-schedules/busline-schedules.gen';

import { useQueryTable } from '@/hooks/useQueryTable';
import DataGrid from '@/components/DataGrid';
import PageContainer from '@/components/layout/PageContainer';
import BuslineQueryFilter from '@/components/QueryFilters/BuslineFilter';
import CompanyQueryFilter from '@/components/QueryFilters/CompanyFilter';
import DataTableToolbar from '@/components/DataTable/DataTableToolbar';
import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';

import { columns, tenantColumns } from './columns';

const BuslineSchedules: React.FC = () => {
  const isTenant = useAuthSessionStore(
    ({ session }) => !session?.organization?.company,
  );
  const {
    query: { isLoading },
    table,
  } = useQueryTable({
    columns: isTenant ? tenantColumns : columns,
    getQueryOptions: getGetBuslineSchedulesQueryOptions,
  });

  return (
    <PageContainer title="Linhas e Horários">
      <DataGrid
        variant="card"
        table={table}
        isLoading={isLoading}
        toolbar={
          <div className="flex items-center space-x-2">
            <DataTableToolbar
              table={table}
              searchPlaceholder="Buscar linha ou horário..."
              searchColumnId="search"
            />
            <BuslineQueryFilter
              title="Linha"
              column={table.getColumn('buslineId')}
            />
            {isTenant && (
              <CompanyQueryFilter
                title="Empresa"
                column={table.getColumn('companyIds')}
              />
            )}
          </div>
        }
      />
    </PageContainer>
  );
};

export default BuslineSchedules;
